export default __webpack_public_path__ + "static/media/UiAgences.8eaeb5a6.svg";